module.exports = __webpack_public_path__ + "img/p1.2be52056.png";